import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0e433b93 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _58dee93b = () => interopDefault(import('../../../pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _e64111b4 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _5f9301d6 = () => interopDefault(import('../../../pages/partners.vue' /* webpackChunkName: "pages/partners" */))
const _1b596bfe = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _18f50744 = () => interopDefault(import('../../../pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _e6e3f0fc = () => interopDefault(import('../../../pages/clients/health-providers.vue' /* webpackChunkName: "pages/clients/health-providers" */))
const _2064d729 = () => interopDefault(import('../../../pages/clients/payers-insurers.vue' /* webpackChunkName: "pages/clients/payers-insurers" */))
const _5be9b4b6 = () => interopDefault(import('../../../pages/products/clinic-management-system.vue' /* webpackChunkName: "pages/products/clinic-management-system" */))
const _1777bf48 = () => interopDefault(import('../../../pages/products/health-claim-management-system.vue' /* webpackChunkName: "pages/products/health-claim-management-system" */))
const _055f4992 = () => interopDefault(import('../../../pages/products/hospital-management-system.vue' /* webpackChunkName: "pages/products/hospital-management-system" */))
const _d81149ea = () => interopDefault(import('../../../pages/products/insurance-member-portal.vue' /* webpackChunkName: "pages/products/insurance-member-portal" */))
const _36f64890 = () => interopDefault(import('../../../pages/products/lab-management-system.vue' /* webpackChunkName: "pages/products/lab-management-system" */))
const _a601af94 = () => interopDefault(import('../../../pages/products/patient-member-portal.vue' /* webpackChunkName: "pages/products/patient-member-portal" */))
const _0a5253c5 = () => interopDefault(import('../../../pages/products/patient-portal.vue' /* webpackChunkName: "pages/products/patient-portal" */))
const _9e0e95fc = () => interopDefault(import('../../../pages/products/payor-system.vue' /* webpackChunkName: "pages/products/payor-system" */))
const _59cd90f0 = () => interopDefault(import('../../../pages/products/pharmacy-management-system.vue' /* webpackChunkName: "pages/products/pharmacy-management-system" */))
const _1f797de2 = () => interopDefault(import('../../../pages/services/software-development-services.vue' /* webpackChunkName: "pages/services/software-development-services" */))
const _18dc8180 = () => interopDefault(import('../../../pages/services/technical-advisory.vue' /* webpackChunkName: "pages/services/technical-advisory" */))
const _2dfb1658 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _0e433b93,
    name: "about___en-hk"
  }, {
    path: "/careers",
    component: _58dee93b,
    name: "careers___en-hk"
  }, {
    path: "/contact",
    component: _e64111b4,
    name: "contact___en-hk"
  }, {
    path: "/partners",
    component: _5f9301d6,
    name: "partners___en-hk"
  }, {
    path: "/privacy-policy",
    component: _1b596bfe,
    name: "privacy-policy___en-hk"
  }, {
    path: "/terms-and-conditions",
    component: _18f50744,
    name: "terms-and-conditions___en-hk"
  }, {
    path: "/clients/health-providers",
    component: _e6e3f0fc,
    name: "clients-health-providers___en-hk"
  }, {
    path: "/clients/payers-insurers",
    component: _2064d729,
    name: "clients-payers-insurers___en-hk"
  }, {
    path: "/products/clinic-management-system",
    component: _5be9b4b6,
    name: "products-clinic-management-system___en-hk"
  }, {
    path: "/products/health-claim-management-system",
    component: _1777bf48,
    name: "products-health-claim-management-system___en-hk"
  }, {
    path: "/products/hospital-management-system",
    component: _055f4992,
    name: "products-hospital-management-system___en-hk"
  }, {
    path: "/products/insurance-member-portal",
    component: _d81149ea,
    name: "products-insurance-member-portal___en-hk"
  }, {
    path: "/products/lab-management-system",
    component: _36f64890,
    name: "products-lab-management-system___en-hk"
  }, {
    path: "/products/patient-member-portal",
    component: _a601af94,
    name: "products-patient-member-portal___en-hk"
  }, {
    path: "/products/patient-portal",
    component: _0a5253c5,
    name: "products-patient-portal___en-hk"
  }, {
    path: "/products/payor-system",
    component: _9e0e95fc,
    name: "products-payor-system___en-hk"
  }, {
    path: "/products/pharmacy-management-system",
    component: _59cd90f0,
    name: "products-pharmacy-management-system___en-hk"
  }, {
    path: "/services/software-development-services",
    component: _1f797de2,
    name: "services-software-development-services___en-hk"
  }, {
    path: "/services/technical-advisory",
    component: _18dc8180,
    name: "services-technical-advisory___en-hk"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index___en-hk"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
